export default __webpack_public_path__ + "static/media/img-08-sahar.67d3dc83.jpg";